<script>
import storageService from "@/services/storage.service";
import Layout from "../../layouts/main";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import axios from "axios";
import statusOptionsMixin from "@/mixins/statusOptions";
import serverTableMixin from "@/mixins/serverTable";
import { downloadApplicationPdf } from "@/services/pdfDownload";
import { formatDate } from "@/helpers/dateFormatter";
import AppIcon from "@/components/shared/AppIcon.vue";
import EcuSelect from "@/components/shared/EcuSelect.vue";
import StatusChip from "@/components/shared/StatusChip.vue";
import TableFooter from "@/components/shared/TableFooter.vue";

export default {
  name: "StaffApplicationList",
  mixins: [statusOptionsMixin, serverTableMixin],
  components: {
    Layout,
    EasyDataTable,
    AppIcon,
    EcuSelect,
    StatusChip,
    TableFooter,
  },
  data() {
    return {
      utype: storageService.getItem("userType"),
      app_id: "",
      review_user: "",
      searchValueTable: "",
      selectFilterSort: null,
      sortFieldMap: {
        number: "application_no",
        applicantName: "name",
        dateLog: "created_on",
        statusLog: "status",
      },
      headers: [
        { text: "Sr. No.", value: "sr" },
        { text: "Application No.", value: "number", sortable: true },
        { text: "Applicant Name", value: "applicantName", sortable: true },
        { text: "Assign Staff", value: "assign" },
        { text: "Date", value: "dateLog", sortable: true },
        { text: "Status", value: "statusLog", sortable: true },
        { text: "Action", value: "view" },
      ],
      items: [],
      arrItem: [],

      // Floating (teleported) action menu state
      menu: { open: false, top: 0, left: 0, item: null, openedAt: 0 },

      // Confirmation Modal State (Verify / Reject)
      showConfirmModal: false,
      confirmAction: "",
      confirmAppId: null,
      confirmAppName: "",
      confirmAppNumber: "",
      confirmComment: "",
      isActionLoading: false,

      // Universal Status Change Modal State
      showStatusChangeModal: false,
      statusChangeAppId: null,
      statusChangeAppName: "",
      statusChangeAppNumber: "",
      statusChangeSelected: "",
      statusChangeCurrent: "",
      actionError: "",
      confirmMeta: {
        verified: { title: "Confirm Application Verification", heading: "Verify Application", verb: "verify", btn: "ecu-m-btn ecu-m-btn--success", icon: "check-circle", tone: "ok" },
        approved: { title: "Confirm Application Approval", heading: "Approve Application", verb: "approve", btn: "ecu-m-btn ecu-m-btn--success", icon: "shield-check", tone: "ok" },
        rejected: { title: "Confirm Application Rejection", heading: "Reject Application", verb: "reject", btn: "ecu-m-btn ecu-m-btn--danger", icon: "x-circle", tone: "bad" },
        incomplete: { title: "Confirm Mark Incomplete", heading: "Mark Incomplete", verb: "mark incomplete", btn: "ecu-m-btn ecu-m-btn--warning", icon: "alert", tone: "warn" },
      },
      statusChangeComment: "",
      isStatusChangeLoading: false,
    };
  },

  computed: {
    statusSelectOptions() {
      return [
        { value: null, label: "All Status" },
        ...this.statusFilterOptions.map((o) => ({ value: o.key, label: o.label })),
      ];
    },
    confirmInfo() {
      return this.confirmMeta[this.confirmAction] || {};
    },
    statusChangeOptions() {
      return this.allowedStatusOptions(this.statusChangeCurrent).map((o) => ({
        value: o.key,
        label: o.label,
      }));
    },
  },

  beforeMount() {
    this.loadTable();
  },

  mounted() {
    // Close the floating menu on outside click, scroll (any container) or resize
    document.addEventListener("mousedown", this.onDocPointer, true);
    window.addEventListener("scroll", this.onScrollClose, true);
    window.addEventListener("resize", this.onScrollClose);
  },

  beforeUnmount() {
    document.removeEventListener("mousedown", this.onDocPointer, true);
    window.removeEventListener("scroll", this.onScrollClose, true);
    window.removeEventListener("resize", this.onScrollClose);
  },

  methods: {
    formatDate,

    // footer controls -> the server-side table options (the mixin reloads on change)
    onPageChange(page) {
      this.serverOptions = { ...this.serverOptions, page };
    },
    onRowsChange(rowsPerPage) {
      this.serverOptions = { ...this.serverOptions, rowsPerPage, page: 1 };
    },

    // clear the search box and reload the table (same behaviour as the Staff page)
    clearSearch() {
      this.searchValueTable = "";
      clearTimeout(this.searchTimer);
      this.resetAndLoad();
    },

    // ---- Floating action menu ----
    menuOptionCount(item) {
      if (!item) return 0;
      let n = 0;
      if (this.allowedStatusOptions(item.statusLog).length) n++;
      if (this.canSet(item, "rejected")) n++;
      if (this.canSet(item, "incomplete")) n++;
      return n;
    },

    toggleMenu(e, item) {
      const r = e.currentTarget.getBoundingClientRect();
      const menuWidth = 210;
      const menuHeight = this.menuOptionCount(item) * 38 + 16;
      const opening = !(this.menu.open && this.menu.item === item);
      const flipUp = r.bottom + menuHeight + 8 > window.innerHeight;
      this.menu = {
        openedAt: Date.now(),
        open: opening,
        top: flipUp ? Math.max(8, r.top - menuHeight - 4) : r.bottom + 4,
        left: Math.max(8, Math.min(r.right - menuWidth, window.innerWidth - menuWidth - 8)),
        item,
      };
    },

    onDocPointer(e) {
      if (!this.menu.open) return;
      const t = e.target;
      if (t && t.closest && (t.closest(".action-menu-fixed") || t.closest(".action-menu-toggle"))) return;
      this.closeMenu();
    },

    onScrollClose(e) {
      if (!this.menu.open) return;
      // ignore scroll noise right after opening and scrolling inside the menu itself
      if (Date.now() - this.menu.openedAt < 400) return;
      if (e && e.target && e.target.nodeType === 1 && e.target.closest(".action-menu-fixed")) return;
      this.closeMenu();
    },

    closeMenu() {
      if (this.menu.open) this.menu.open = false;
    },

    menuChangeStatus() {
      const item = this.menu.item;
      this.closeMenu();
      if (item) this.openStatusChangeModal(item);
    },

    menuPrompt(action) {
      const item = this.menu.item;
      this.closeMenu();
      if (item) this.promptAction(action, item);
    },

    // ---- Data ----
    downloadPdf(item) {
      return downloadApplicationPdf(item.app_id, item.number);
    },

    requestTable(params) {
      return axios.get("/applications/all_application_details/", { params });
    },

    applyTable(data) {
      this.review_user = storageService.getItem("accessToken");
      const offset =
        (this.serverOptions.page - 1) * this.serverOptions.rowsPerPage;
      this.arrItem = (data.results || []).map((item, index) => {
        let tok = false;
        if (item.app_status === "yes") {
          tok = item.user !== this.review_user;
        }
        const secName = item.section_a1
          ? `${item.section_a1.first_name || ""} ${item.section_a1.sur_name || ""}`.trim()
          : "";
        const appName = item.applicant_name
          ? item.applicant_name
          : item.applicant
          ? `${item.applicant.first_name || ""} ${item.applicant.last_name || ""}`.trim() || item.applicant.username
          : "";
        const rawDate = item.formatted_date || item.created_on || item.created_at;
        return {
          sr: offset + index + 1,
          app_id: item.id,
          number: item.application_no || `ECU-${String(item.id).padStart(6, "0")}`,
          applicantName: secName || appName || "N/A",
          assign: item.rev || "N/A",
          dateLog: formatDate(rawDate),
          statusLog: item.status,
          user_tok: tok,
        };
      });
    },

    canSet(item, key) {
      return this.allowedStatusOptions(item.statusLog).some((o) => o.key === key);
    },

    promptAction(action, item) {
      this.actionError = "";
      this.confirmAction = action;
      this.confirmAppId = item.app_id;
      this.confirmAppName = item.applicantName;
      this.confirmAppNumber = item.number;
      this.confirmComment = "";
      this.showConfirmModal = true;
    },

    executeConfirmAction() {
      if (!this.confirmAppId) return;
      this.isActionLoading = true;
      const accessToken = storageService.getItem("accessToken");
      axios
        .post("/applications/updateappstatus/", {
          access_token: accessToken,
          action: this.confirmAction,
          aid: this.confirmAppId,
          comment: this.confirmComment,
        })
        .then((response) => {
          if (response.data.status === "SUCCESS") {
            const targetId = this.confirmAppId;
            const newStatus = response.data.newstatus || this.confirmAction;
            const updateRow = (arr) => {
              const row = (arr || []).find((r) => r.app_id === targetId);
              if (row) row.statusLog = newStatus;
            };
            updateRow(this.arrItem);
            updateRow(this.items);
            this.showConfirmModal = false;
            this.loadTable(true);
          }
        })
        .catch((error) => {
          this.actionError =
            (error.response && error.response.data && error.response.data.error) ||
            "Could not update the status.";
        })
        .finally(() => {
          this.isActionLoading = false;
        });
    },

    openStatusChangeModal(item) {
      this.statusChangeAppId = item.app_id;
      this.statusChangeAppName = item.applicantName;
      this.statusChangeAppNumber = item.number;
      this.statusChangeCurrent = item.statusLog;
      this.statusChangeSelected = "";
      this.actionError = "";
      this.statusChangeComment = "";
      this.showStatusChangeModal = true;
    },

    executeStatusChange() {
      if (!this.statusChangeAppId || !this.statusChangeSelected) return;
      this.isStatusChangeLoading = true;
      const accessToken = storageService.getItem("accessToken");
      axios
        .post("/applications/updateappstatus/", {
          access_token: accessToken,
          action: this.statusChangeSelected,
          aid: this.statusChangeAppId,
          comment: this.statusChangeComment,
        })
        .then((response) => {
          if (response.data.status === "SUCCESS") {
            const targetId = this.statusChangeAppId;
            const newStatus = response.data.newstatus || this.statusChangeSelected;
            const updateRow = (arr) => {
              const row = (arr || []).find((r) => r.app_id === targetId);
              if (row) row.statusLog = newStatus;
            };
            updateRow(this.arrItem);
            updateRow(this.items);
            this.showStatusChangeModal = false;
            this.loadTable(true);
          }
        })
        .catch((error) => {
          this.actionError =
            (error.response && error.response.data && error.response.data.error) ||
            "Could not update the status.";
        })
        .finally(() => {
          this.isStatusChangeLoading = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <section class="alist">
      <!-- Heading (left) + search / filter (right), on one line -->
      <header class="ecu-page-head alist__head">
        <div>
          <h1>All Applications</h1>
          <p class="ecu-page-head__sub">Review, verify and track membership applications.</p>
        </div>

        <div class="alist__tools">
          <div class="ecu-field ecu-field--search">
            <AppIcon name="search" :size="18" />
            <input
              type="text"
              v-model="searchValueTable"
              @input="onSearchInput"
              placeholder="Search application..."
              aria-label="Search application"
            />
            <button
              v-if="searchValueTable"
              type="button"
              class="alist__clear"
              aria-label="Clear search"
              @click="clearSearch"
            >
              <AppIcon name="x" :size="14" :stroke="2.4" />
            </button>
          </div>

          <EcuSelect
            v-model="selectFilterSort"
            class="ecu-filter-select"
            :options="statusSelectOptions"
            aria-label="Filter by status"
            @change="onStatusChange"
          />
        </div>
      </header>

      <div class="ecu-card">
        <div class="ecu-table-wrap alist__table">
          <EasyDataTable
            :headers="headers"
            :items="arrItem"
            v-model:server-options="serverOptions"
            :server-items-length="totalItems"
            :loading="tableLoading"
            :rows-items="[10, 20, 50, 100]"
            empty-message="No applications found"
            theme-color="#f97316"
            hide-footer
            table-class-name="table-custom-style noWrapHeading"
          >
            <template #item-number="{ number }">
              <span class="ecu-strong">{{ number }}</span>
            </template>

            <template #item-dateLog="{ dateLog }">
              <span class="ecu-date">
                <AppIcon name="calendar" :size="16" />
                {{ dateLog }}
              </span>
            </template>

            <template #item-statusLog="{ statusLog }">
              <StatusChip :status="statusLog" />
            </template>

            <template #item-view="item">
              <div class="ecu-actions">
                <router-link
                  :to="`/view_application/${item.app_id}`"
                  class="ecu-btn-view"
                  title="View Application"
                >
                  <AppIcon name="eye" :size="16" /> View
                </router-link>

                <button
                  type="button"
                  class="ecu-btn-view"
                  title="Download PDF"
                  @click="downloadPdf(item)"
                >
                  <AppIcon name="download" :size="16" /> PDF
                </button>

                <!-- Verified: Approve / Reject -->
                <template v-if="item.statusLog === 'verified'">
                  <button
                    v-if="canSet(item, 'approved')"
                    type="button"
                    class="ecu-btn-view ecu-btn-view--success"
                    @click="promptAction('approved', item)"
                  >
                    <AppIcon name="check-circle" :size="16" /> Approve
                  </button>
                  <button
                    v-if="canSet(item, 'rejected')"
                    type="button"
                    class="ecu-btn-view ecu-btn-view--danger"
                    @click="promptAction('rejected', item)"
                  >
                    Reject
                  </button>
                </template>

                <!-- Approved / Rejected are final: no further actions -->
                <template v-else-if="item.statusLog !== 'approved' && item.statusLog !== 'rejected'">
                  <template v-if="utype == 'staff'">
                    <router-link
                      v-if="!item.user_tok"
                      :to="`/review_application/${item.app_id}`"
                      class="ecu-btn-view ecu-btn-view--solid"
                    >
                      Review
                    </router-link>
                    <span
                      v-else
                      class="ecu-btn-view ecu-btn-view--solid is-disabled"
                      aria-disabled="true"
                    >
                      Review
                    </span>
                  </template>

                  <button
                    v-if="canSet(item, 'verified')"
                    type="button"
                    class="ecu-btn-view ecu-btn-view--success"
                    @click="promptAction('verified', item)"
                  >
                    <AppIcon name="check" :size="16" /> Verify
                  </button>

                  <!-- More button (the menu itself is teleported to <body>) -->
                  <button
                    v-if="menuOptionCount(item)"
                    type="button"
                    class="ecu-btn-icon action-menu-toggle"
                    title="More actions"
                    aria-label="More actions"
                    aria-haspopup="true"
                    :aria-expanded="menu.open && menu.item === item ? 'true' : 'false'"
                    @click="toggleMenu($event, item)"
                  >
                    <AppIcon name="more-vertical" :size="18" :stroke="2.6" />
                  </button>
                </template>
              </div>
            </template>
          </EasyDataTable>
        </div>

        <TableFooter
          :page="serverOptions.page"
          :rows-per-page="serverOptions.rowsPerPage"
          :total="totalItems"
          :loading="tableLoading"
          @update:page="onPageChange"
          @update:rowsPerPage="onRowsChange"
        />

        <!-- Confirmation modal (Verify / Approve / Reject / Incomplete) -->
        <b-modal
          v-model="showConfirmModal"
          :title="confirmInfo.title"
          hide-footer
          centered
        >
          <div class="ecu-m-confirm">
            <span class="ecu-m-confirm__icon" :class="`ecu-m-confirm__icon--${confirmInfo.tone}`">
              <AppIcon :name="confirmInfo.icon || 'info'" :size="30" />
            </span>
            <h5>{{ confirmInfo.heading }}</h5>
            <p>
              Are you sure you want to <strong>{{ confirmInfo.verb }}</strong> application
              <strong>{{ confirmAppNumber }}</strong> ({{ confirmAppName }})?
            </p>
          </div>

          <div
            v-if="confirmAction === 'rejected' || confirmAction === 'incomplete'"
            class="ecu-m-field alist__note"
          >
            <label class="ecu-m-label">Reason / Note (Optional)</label>
            <textarea
              v-model="confirmComment"
              class="ecu-m-input ecu-m-textarea"
              rows="3"
              placeholder="Enter reason for rejection..."
            ></textarea>
          </div>

          <p v-if="actionError" class="ecu-m-alert ecu-m-alert--error alist__note">
            <AppIcon name="alert" :size="18" /> {{ actionError }}
          </p>

          <div class="ecu-m-actions ecu-m-actions--center">
            <button
              type="button"
              class="ecu-m-btn ecu-m-btn--ghost"
              :disabled="isActionLoading"
              @click="showConfirmModal = false"
            >
              Cancel
            </button>
            <button
              type="button"
              :class="confirmInfo.btn || 'ecu-m-btn'"
              :disabled="isActionLoading"
              @click="executeConfirmAction"
            >
              <span v-if="isActionLoading">Processing...</span>
              <span v-else>Confirm</span>
            </button>
          </div>
        </b-modal>

        <!-- Status change modal -->
        <b-modal
          v-model="showStatusChangeModal"
          title="Update Application Status"
          hide-footer
          centered
        >
          <p class="alist__meta">
            Application: <strong>{{ statusChangeAppNumber }}</strong> ({{ statusChangeAppName }})
          </p>

          <div class="ecu-m-field alist__note">
            <label class="ecu-m-label">Select New Status</label>
            <EcuSelect
              v-model="statusChangeSelected"
              :options="statusChangeOptions"
              placeholder="Select new status"
              aria-label="New status"
            />
          </div>

          <div class="ecu-m-field alist__note">
            <label class="ecu-m-label">Comments / Audit Note</label>
            <textarea
              v-model="statusChangeComment"
              class="ecu-m-input ecu-m-textarea"
              rows="3"
              placeholder="Reason or notes regarding this status change..."
            ></textarea>
          </div>

          <p v-if="actionError" class="ecu-m-alert ecu-m-alert--error alist__note">
            <AppIcon name="alert" :size="18" /> {{ actionError }}
          </p>

          <div class="ecu-m-actions">
            <button
              type="button"
              class="ecu-m-btn ecu-m-btn--ghost"
              :disabled="isStatusChangeLoading"
              @click="showStatusChangeModal = false"
            >
              Cancel
            </button>
            <button
              type="button"
              class="ecu-m-btn"
              :disabled="isStatusChangeLoading || !statusChangeSelected"
              @click="executeStatusChange"
            >
              <span v-if="isStatusChangeLoading">Saving...</span>
              <span v-else>Save Status</span>
            </button>
          </div>
        </b-modal>
      </div>
    </section>

    <!-- Floating action menu: rendered on <body> so no table/overflow container can clip it -->
    <Teleport to="body">
      <ul
        v-if="menu.open && menu.item"
        class="action-menu-fixed"
        :style="{ top: menu.top + 'px', left: menu.left + 'px' }"
      >
        <li v-if="allowedStatusOptions(menu.item.statusLog).length">
          <a class="dropdown-item" href="#" @click.prevent="menuChangeStatus">
            <AppIcon name="edit" :size="16" /> Change Status
          </a>
        </li>
        <li v-if="canSet(menu.item, 'rejected')">
          <a class="dropdown-item dropdown-item--danger" href="#" @click.prevent="menuPrompt('rejected')">
            <AppIcon name="x-circle" :size="16" /> Reject Application
          </a>
        </li>
        <li v-if="canSet(menu.item, 'incomplete')">
          <a class="dropdown-item dropdown-item--warn" href="#" @click.prevent="menuPrompt('incomplete')">
            <AppIcon name="alert" :size="16" /> Mark Incomplete
          </a>
        </li>
      </ul>
    </Teleport>
  </Layout>
</template>

<style scoped>
.alist {
  display: flex;
  flex-direction: column;
  gap: 22px;
  zoom: 0.9; /* 20% smaller */
}
.alist .ecu-page-head {
  margin-bottom: 0;
}
/* heading on the left, search + filter on the right, vertically aligned */
.alist__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.alist__tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-left: auto;
}
.alist__tools .ecu-field--search {
  position: relative;
  min-width: 260px;
}
.alist__tools .ecu-field--search input {
  padding-right: 40px;
}
/* clear (X) button inside the search box */
.alist__clear {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #5f6579;
  cursor: pointer;
}
.alist__clear:hover {
  color: #e84d00;
}
.alist .ecu-card {
  padding: 22px 22px 18px;
}
.alist .ecu-toolbar .ecu-tile {
  background: transparent;
}
.alist__meta {
  margin: 0 0 4px;
  font-size: 13.5px;
  color: var(--ecu-muted, #5f6579);
}
.alist__meta strong {
  color: var(--ecu-navy, #0b1f4b);
}
.alist__note {
  margin-top: 18px;
  margin-bottom: 0;
}
/* every column label and cell value in capitalised words */
.alist__table :deep(th),
.alist__table :deep(td),
.alist__table :deep(td *) {
  text-transform: capitalize;
}
@media (max-width: 767px) {
  .alist .ecu-card {
    padding: 16px 14px 14px;
  }
  .alist__tools {
    width: 100%;
    margin-left: 0;
    flex-wrap: wrap;
  }
  .alist__tools .ecu-field--search {
    flex: 1 1 100%;
    min-width: 0;
  }
}
</style>

<style>
/* Floating action menu, teleported to <body> so it is never clipped by the table. */
.action-menu-fixed {
  position: fixed;
  display: block;
  min-width: 210px;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: #fff;
  border: 1px solid rgba(11, 31, 75, 0.08);
  border-radius: 14px;
  box-shadow: 0 18px 44px rgba(11, 31, 75, 0.18);
  font-family: "Plus Jakarta Sans", "Inter", "Segoe UI", system-ui, -apple-system, sans-serif;
  z-index: 99999;
}
.action-menu-fixed .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 9px;
  color: #1d2a4d;
  font-size: 13.5px;
  font-weight: 600;
  text-decoration: none;
  text-transform: capitalize;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s ease, color 0.18s ease;
}
.action-menu-fixed .dropdown-item .app-icon {
  color: #f97316;
}
.action-menu-fixed .dropdown-item:hover {
  background: #fff1e6;
  color: #e84d00;
}
.action-menu-fixed .dropdown-item--danger,
.action-menu-fixed .dropdown-item--danger .app-icon {
  color: #c52222;
}
.action-menu-fixed .dropdown-item--danger:hover {
  background: #fde9e9;
  color: #c52222;
}
.action-menu-fixed .dropdown-item--warn .app-icon {
  color: #d18a00;
}
</style>